import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { analyticsAPI, adminAPI } from '../../utils/api';
import { PackagePlus } from 'lucide-react';
import toast from 'react-hot-toast';

export default function AdminInventoryPage() {
  const qc = useQueryClient();
  const [adjusting, setAdjusting] = useState(null);
  const [adjQty, setAdjQty] = useState('');
  const [adjNote, setAdjNote] = useState('');

  const { data, isLoading } = useQuery({
    queryKey: ['inventory'],
    queryFn: () => analyticsAPI.inventory().then(r => r.data),
  });

  const adjMut = useMutation({
    mutationFn: adminAPI.adjustInventory,
    onSuccess: () => {
      toast.success('Stoku u rregullua!');
      qc.invalidateQueries(['inventory']);
      setAdjusting(null); setAdjQty(''); setAdjNote('');
    },
    onError: (e) => toast.error(e.response?.data?.error || 'Gabim'),
  });

  return (
    <div>
      <h1 style={{ fontSize:'1.6rem',marginBottom:4 }}>Inventari</h1>
      <p style={{ color:'var(--text-light)',fontSize:'.88rem',marginBottom:24 }}>Menaxho stokun e produkteve</p>
      <div className="card" style={{ padding:0,overflow:'hidden' }}>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Produkti</th><th>SKU</th><th>Stoku</th><th>Pragu</th><th>Çmimi</th><th>Veprime</th></tr></thead>
            <tbody>
              {isLoading && <tr><td colSpan={6} style={{ textAlign:'center',padding:40 }}><div className="spinner" style={{ margin:'0 auto' }} /></td></tr>}
              {data?.products?.map(p => (
                <tr key={p.id}>
                  <td style={{ fontWeight:500 }}>{p.name}</td>
                  <td><code style={{ fontSize:'.78rem',background:'var(--cream)',padding:'2px 8px',borderRadius:4 }}>{p.sku}</code></td>
                  <td><span className={`badge ${p.stock === 0 ? 'badge-red' : p.stock <= p.low_stock_threshold ? 'badge-gold' : 'badge-green'}`}>{p.stock}</span></td>
                  <td style={{ color:'var(--text-light)',fontSize:'.85rem' }}>{p.low_stock_threshold}</td>
                  <td>${p.price}</td>
                  <td>
                    <button className="btn btn-primary btn-sm" onClick={() => setAdjusting(p)}>
                      <PackagePlus size={14} /> Rregullon
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {adjusting && (
        <div style={{ position:'fixed',inset:0,background:'rgba(0,0,0,.4)',zIndex:2000,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}
          onClick={e => e.target === e.currentTarget && setAdjusting(null)}>
          <div style={{ background:'white',borderRadius:'var(--radius-xl)',width:'min(420px,100%)',padding:32 }}>
            <h2 style={{ fontSize:'1.1rem',marginBottom:20 }}>Rregullon: {adjusting.name}</h2>
            <p style={{ marginBottom:16,fontSize:'.9rem',color:'var(--text-light)' }}>Stoku aktual: <strong style={{ color:'var(--green-deep)' }}>{adjusting.stock}</strong></p>
            <div className="form-group"><label className="form-label">Ndryshim (+/-)</label>
              <input className="form-input" type="number" placeholder="+50 ose -10" value={adjQty} onChange={e => setAdjQty(e.target.value)} />
            </div>
            <div className="form-group"><label className="form-label">Shënim</label>
              <input className="form-input" placeholder="Arsyeja..." value={adjNote} onChange={e => setAdjNote(e.target.value)} />
            </div>
            <div style={{ display:'flex',gap:12,justifyContent:'flex-end',marginTop:20 }}>
              <button className="btn btn-ghost" onClick={() => setAdjusting(null)}>Anulo</button>
              <button className="btn btn-primary" disabled={!adjQty || adjMut.isPending}
                onClick={() => adjMut.mutate({ product_id: adjusting.id, quantity: +adjQty, note: adjNote })}>
                {adjMut.isPending ? 'Duke aplikuar...' : 'Apliko'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
